import { render, staticRenderFns } from "./SetAdvertRelations.vue?vue&type=template&id=8abdb72e&scoped=true"
import script from "./SetAdvertRelations.vue?vue&type=script&lang=js"
export * from "./SetAdvertRelations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abdb72e",
  null
  
)

export default component.exports